import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridShowOnlyEmpty';
const DEFAULT_VALUE = false;

export const useShowOnlyEmpty = () => {
	const [showOnlyEmpty, setShowOnlyEmpty] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { showOnlyEmpty, setShowOnlyEmpty };
};
